import { useCallback, useEffect, useMemo, useRef, useReducer } from "react";

import getPagination from "./getPagination";
import paginationStateReducer from "./paginationStateReducer";

function useCustomPagination({
  initialPage = 0,
  initialItemsPerPage = 0,
  totalItems = 0,
}) {
  const [paginationState, paginationDispatch] = useReducer(
    paginationStateReducer,
    {
      currentPage: initialPage,
      itemsPerPage: initialItemsPerPage,
      totalItems,
    },
  );

  const totalItemsRef = useRef(totalItems);
  totalItemsRef.current = totalItems;

  useEffect(() => {
    // Reset to initialPage when it changes
    paginationDispatch({ type: "GO_TO_PAGE", page: initialPage });
  }, [initialPage]);

  useEffect(
    () => () => {
      if (totalItemsRef.current !== totalItems) {
        paginationDispatch({
          type: "SET_TOTAL_ITEMS",
          totalItems: totalItemsRef.current,
        });
      }
    },
    [totalItems],
  );

  return {
    ...paginationState,

    ...useMemo(
      () =>
        getPagination({
          ...paginationState,
        }),
      [paginationState],
    ),

    setPage: useCallback((page) => {
      paginationDispatch({ type: "GO_TO_PAGE", page });
    }, []),

    setNextPage: useCallback(() => {
      paginationDispatch({ type: "NEXT_PAGE" });
    }, []),

    setPreviousPage: useCallback(() => {
      paginationDispatch({ type: "PREVIOUS_PAGE" });
    }, []),

    setItemsPerPage: useCallback((itemsPerPage) => {
      paginationDispatch({ type: "SET_ITEMS_PER_PAGE", itemsPerPage });
    }, []),
  };
}

export default useCustomPagination;
